<header class="container" class="clearfix">
  <a routerLink="/" routerLinkActive="active" class="logo">
    <img style="width: 132px;" src="../../assets/img/logo.png" />
  </a>
  <nav>
    <ul class="clearfix">
      @if (exibeBtnLogin && !autenticado) {
        <li><a routerLink="/autenticacao/login" routerLinkActive="active">Login</a></li>
      }
      @if (autenticado) {
        <li class="usu-nome"><span class="font-weight-light">Olá </span><span>{{credenciais?.nome}}</span></li>
      }
      @if (autenticado) {
        <li><a class="logout" href="" (click)="sair();false">Sair</a></li>
      }
    </ul>
  </nav>
</header>
<router-outlet></router-outlet>
